import React, {Component} from 'react';
import '../../style.css';
import {Button, Form, Input, message, Modal, PageHeader, Space, Tag, Tooltip, Typography} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;

class RDCenter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            RDData:[
                {
                    companyName: "公司2",
                    introduction: '',
                    rdIntroduction: '',
                    allNum: "100",
                    juniorNum: "90",
                    technicalNum: "21",
                    percentage: "21.0",
                    countProject: "4",
                    countPatent: "1",
                    averageCountPatent: "0",
                    countAuthorizedPatent: "1",
                    time: '',
                }
            ],
            introduction: '',
            rdIntroduction: '',
            allNum: "100",
            juniorNum: "90",
            technicalNum: "21",
            percentage: "21.0",
            countProject: "4",
            countPatent: "1",
            averageCountPatent: "0",
            countAuthorizedPatent: "1",
            time: '',
            status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getRDCenterS, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            RDData:res.data,
                            companyName:res.data.companyName,
                            introduction: res.data.introduction,
                            rdIntroduction: res.data.rdIntroduction,
                            allNum: res.data.allNum,
                            juniorNum: res.data.juniorNum,
                            technicalNum: res.data.technicalNum,
                            percentage:res.data.percentage,
                            countProject: res.data.countProject,
                            countPatent: res.data.countPatent,
                            averageCountPatent: res.data.averageCountPatent,
                            countAuthorizedPatent: res.data.countAuthorizedPatent,
                            time: res.data.time,
                        }))
                    }
                    else{
                        message.info("该材料未填写数据，请填写").then()
                        this.setState(()=>({
                            status:true,
                        }))
                    }
                }
            )
    }
    edit(){
        this.setState(()=>({
            status:true,
        }))
    }
    submit(){
        if(this.state.introduction === ''||this.state.rdIntroduction === ''||this.state.time === ''
            ||this.state.allNum === ''||this.state.juniorNum === ''||this.state.technicalNum === ''
            ||this.state.percentage === ''||this.state.countProject === ''||this.state.countPatent === ''
            ||this.state.averageCountPatent === ''||this.state.countAuthorizedPatent === ''
        ){
            message.info("请检查信息是否填写完整").then()
        }else{
            let params={
                companyId:this.state.companyId,
                companyName:this.state.companyName,
                introduction: this.state.introduction,
                rdIntroduction: this.state.rdIntroduction,
                allNum: this.state.allNum,
                juniorNum:this.state.juniorNum,
                technicalNum: this.state.technicalNum,
                percentage:this.state.percentage,
                countProject: this.state.countProject,
                countPatent: this.state.countPatent,
                averageCountPatent: this.state.averageCountPatent,
                countAuthorizedPatent: this.state.countAuthorizedPatent,
                time: this.state.time,
            }
            fetchPost(global.constants.updateRDCenter,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getRDCenterS, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                RDData:res.data,
                                                status:false,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    handleExportClick(){
        fetchPost(global.constants.exportRDCenterS, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-23研发中心建设情况说明.doc',
            fileName: '研发中心建设情况说明.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    this.setState(()=>({
                        fileStream:res
                    }))
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-23研发中心建设情况说明.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-23研发中心建设情况说明.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/研发中心建设情况说明.pdf',
                            fileName: '研发中心建设情况说明.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发中心建设情况说明',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'研发中心建设情况说明',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','研发中心建设情况说明');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'研发中心建设情况说明',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'研发中心建设情况说明',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="研发中心建设情况说明"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <div className="content-frame-wordStyle">
                    <div className="content-form-wordStyle">
                        <div className = "word">
                        <span className="word-title">
                            研发中心建设情况说明
                        </span>
                        </div>
                        <Space direction="vertical" >
                            <Typography>
                                <Paragraph className="textStyle-bold">
                                    一、管理与研究开发人员情况
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    {this.state.RDData.companyName}
                                    {
                                        this.state.RDData.introduction === null || this.state.status === true?
                                            <Input
                                                placeholder={'请填写公司介绍'}
                                                defaultValue={this.state.RDData.introduction}
                                                autoSize={{ minRows: 1, maxRows: 2 }}
                                                onChange={this.introductionChange.bind(this)}
                                            />:this.state.RDData.introduction
                                    }
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    {
                                        this.state.RDData.rdIntroduction === null || this.state.status === true?
                                            <Input
                                                placeholder={'请填写研发中心介绍'}
                                                defaultValue={this.state.RDData.rdIntroduction}
                                                autoSize={{ minRows: 1, maxRows: 2 }}
                                                onChange={this.rdIntroductionChange.bind(this)}
                                            />:this.state.RDData.rdIntroduction
                                    }
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    公司在职员工
                                    {
                                        this.state.RDData.allNum === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.allNum}
                                                   onChange={this.allNumChange.bind(this)}/>:
                                            this.state.RDData.allNum
                                    }
                                    人，
                                    专科及以上学历人员有
                                    {
                                        this.state.RDData.juniorNum === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.juniorNum}
                                                   onChange={this.juniorNumChange.bind(this)}/>:
                                            this.state.RDData.juniorNum
                                    }
                                    人，
                                    科技人员
                                    {
                                        this.state.RDData.technicalNum === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.technicalNum}
                                                   onChange={this.technicalNumChange.bind(this)}/>:
                                            this.state.RDData.technicalNum
                                    }
                                    人，
                                    占职工总数的
                                    {
                                        this.state.RDData.percentage === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.percentage}
                                                   onChange={this.percentageChange.bind(this)}/>:
                                            this.state.RDData.percentage
                                    }
                                    %以上。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    二、科技成果转化及研发开发管理情况
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    科技成果转化方面，
                                    公司近三年开展
                                    {
                                        this.state.RDData.countProject === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.countProject}
                                                   onChange={this.countProjectChange.bind(this)}/>:
                                            this.state.RDData.countProject
                                    }
                                    项研发项目，
                                    实现成果转化
                                    {
                                        this.state.RDData.countPatent === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.countPatent}
                                                   onChange={this.countPatentChange.bind(this)}/>:
                                            this.state.RDData.countPatent
                                    }
                                    项，
                                    年平均转化
                                    {
                                        this.state.RDData.averageCountPatent === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.averageCountPatent}
                                                   onChange={this.averageCountPatentChange.bind(this)}/>:
                                            this.state.RDData.averageCountPatent
                                    }
                                    项，
                                    技术水平处于国内先进水平，经济效益显著。
                                    另外，公司近三年已取
                                    {
                                        this.state.RDData.countAuthorizedPatent === null || this.state.status === true?
                                            <Input className="input_style"
                                                   defaultValue={this.state.RDData.countAuthorizedPatent}
                                                   onChange={this.countAuthorizedPatentChange.bind(this)}/>:
                                            this.state.RDData.countAuthorizedPatent
                                    }
                                    项实用新型专利。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    研究管理方面，作为技术创新型企业，我公司重视新技术、新产品的研究开发，
                                    设立专门的研发部门以及研发人员绩效管理制度持续进行研发投入。同时，建立了健全的研发管理制度体系，
                                    包括《研发项目管理制度》《科技成果转化的组织实施与激励奖励制度》《研发部绩效考核管理办法》等制度，
                                    对研发活动进行严格的过程控制和考核。
                                </Paragraph>
                                <div style={{float:'right',marginRight:'10%'}}>
                                    <Paragraph className="textStyle">
                                        {this.state.companyName}
                                    </Paragraph>
                                    <Paragraph className="textStyle">
                                        {
                                            this.state.RDData.time === null || this.state.status === true?
                                                <Input className="input_style"
                                                       placeholder={'请填写文件时间'}
                                                       defaultValue={this.state.RDData.time}
                                                       onChange={this.timeChange.bind(this)}/>:
                                                this.state.RDData.time
                                        }
                                    </Paragraph>
                                </div>
                            </Typography>
                            <div>
                                <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                                <Button
                                    disabled={this.state.status}
                                    type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                            </div>
                        </Space>
                        <Modal
                            visible={this.state.preview_visible}
                            title={'预览'}
                            onCancel={this.hideModal}
                            destroyOnClose
                            width={'50%'}
                            footer={[
                                <Button key="back" onClick={this.hideModal}>
                                    取消
                                </Button>,
                                <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                    下载
                                </Button>,
                            ]}
                        >
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                        </Modal>
                        <Modal
                            visible={this.state.upload_visible}
                            title={'上传附件'}
                            onCancel={this.hideModal.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModal.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                                    完成
                                </Button>,
                            ]}
                        >
                            <div>
                                该公司的研发中心建设情况说明
                                {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                                <Form style={{marginTop:'20px'}}>
                                    <Form.Item
                                        name='file'
                                        method="post"
                                        enctype="multipart/form-data"
                                    >
                                        <input
                                            type="file"
                                            name='file'
                                            onChange={this.fileInput.bind(this)}
                                        />
                                    </Form.Item>
                                    <Form.Item name="preview_paper">
                                        {
                                            this.state.checkStatus === true &&
                                            <div>
                                                <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                                <FileViewer fileType='pdf'
                                                            filePath={this.state.fileStream_upload}
                                                            onError={this.onError}
                                                />
                                            </div>
                                        }
                                    </Form.Item>
                                </Form>
                            </div>
                        </Modal>
                        <Modal
                            visible={this.state.uploadFile_visible}
                            title={'上传'}
                            onCancel={this.hideModalTwo.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                                    确定
                                </Button>,
                            ]}
                        >
                            <div>确定上传该研发中心建设情况说明吗？</div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
    introductionChange(e){
        const value = e.target.value
        this.setState(()=>({
            introduction:value
        }))
    }
    rdIntroductionChange(e){
        const value = e.target.value
        this.setState(()=>({
            rdIntroduction:value
        }))
    }
    allNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            allNum:value
        }))
    }
    juniorNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            juniorNum:value
        }))
    }
    technicalNumChange(e){
        const value = e.target.value
        this.setState(()=>({
            technicalNum:value
        }))
    }
    percentageChange(e){
        const value = e.target.value
        this.setState(()=>({
            percentage:value
        }))
    }
    countProjectChange(e){
        const value = e.target.value
        this.setState(()=>({
            countProject:value
        }))
    }
    countPatentChange(e){
        const value = e.target.value
        this.setState(()=>({
            countPatent:value
        }))
    }
    averageCountPatentChange(e){
        const value = e.target.value
        this.setState(()=>({
            averageCountPatent:value
        }))
    }
    countAuthorizedPatentChange(e){
        const value = e.target.value
        this.setState(()=>({
            countAuthorizedPatent:value
        }))
    }
    timeChange(e){
        const value = e.target.value
        this.setState(()=>({
            time:value
        }))
    }
}

export default RDCenter